import { render, staticRenderFns } from "./phone-num.vue?vue&type=template&id=187ba977&scoped=true&lang=pug"
import script from "./phone-num.vue?vue&type=script&lang=js"
export * from "./phone-num.vue?vue&type=script&lang=js"
import style0 from "./phone-num.vue?vue&type=style&index=0&id=187ba977&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "187ba977",
  null
  
)

export default component.exports